import { ReferenceOptions } from '@/components/form/ReferenceOptions';
import { SelectField } from '@/components/form/SelectField';

/** Rôle dans la société (Dirigeant, Assistant, Employé), à l'ajout d'un employé */
export function CompanyRoleField({
  id,
  value,
  onChange,
}: {
  id: string;
  value: string;
  onChange: (companyRole: string) => void;
}) {
  return (
    <SelectField id={id} label="Rôle dans la société" required value={value} onChange={(e) => onChange(e.target.value)}>
      <ReferenceOptions name="companyRoles" />
    </SelectField>
  );
}
